"use strict";

require("core-js/modules/es6.function.bind");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var node_fetch_1 = __importDefault(require("node-fetch"));

module.exports = // istanbul ignore next
typeof window === 'undefined' ? node_fetch_1["default"] : window.fetch.bind(window);